<div class="panel-body ">
  <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top" 
      *ngIf="civilCase.getTransferedFromCaseNumber() !== '-' || civilCase.getTransferedToCaseNumber() !== '-'">
    <div id="X303" class="panel-title ">
        Transfer between Jurisdictions
    </div>
    <div class="panel-body">
      <div class="table-responsive" [class.scroll-hide-xy]="civilCase.getTransferedToCaseNumber() === '-'">
      <table id="transferAppeals-betweenJurisdictions-table" class="table table-condensed table-striped ">
        <thead>
          <tr>
            <th id="V303">
              Transferred On
            </th>
            <th id="V003c">
              From
            </th>
            <th id="V003d">
              To
            </th>
          </tr>
        </thead>
        <tbody>
          <tr  *ngIf="civilCase.getTransferedFromCaseNumber() !== '-'">
            <td id="{{'civil-caseDetails-transferAppeals-toCaseFromField-clockDateByCaseEventCode'}}">
              <span class="field-code ">V303 json='transferedFromCase.caseNumber.fileNumber#','caseEventList.caseEvent.code'</span>
              {{civilCase.getTransferedFromCaseDate() | date:'MM/dd/yyyy'}}
            </td>
            <td id="{{'civil-caseDetails-transferAppeals-toCaseFromField-transferedToCaseFromField'}}">
              <span class="field-code ">V003c json='transferedFromCase.caseNumber.fileNumber#','transferedFromCase.caseNumber.fileNumber'</span>
              {{civilCase.getTransferedFromCaseNumber()}}
            </td>
            <td id="{{'civil-caseDetails-transferAppeals-toCaseFromField-dateTime'}}">
              <span class="field-code ">V003d json='transferedFromCase.caseNumber.fileNumber#','civilCase.caseNumber.fileNumber'</span>
             {{civilCase.getCaseNumber()}}
            </td>
          </tr>
          <tr *ngIf="civilCase.getTransferedToCaseNumber() !== '-'">
            <td id="{{'civil-caseDetails-transferAppeals-toCaseToField-clockDateByCaseEventCode'}}">
              <span id="V303" class="field-code " >V303 json='transferedToCase.caseNumber.fileNumber#','caseEventList.caseEvent.code#','caseEventList.clockDate'</span>              
              {{civilCase.getTransferedToCaseDate() | date:'MM/dd/yyyy'}}
            </td>
            <td id="{{'civil-caseDetails-transferAppeals-toCaseToField-caseNumber'}}">
              <span class="field-code ">V003c json='transferedToCase.caseNumber.fileNumber#','civilCase.caseNumber.fileNumber'</span>              
              {{civilCase.getCaseNumber()}}
            </td>
            <td id="{{'civil-caseDetails-transferAppeals-toCaseToField-transferedToCaseToField'}}">
              <span class="field-code ">V003d json='transferedToCase.caseNumber.fileNumber#','transferedToCase.caseNumber.fileNumber'</span>
             {{civilCase.getTransferedToCaseNumber()}}
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>
  </div>

  <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top"
      *ngIf="civilCase.getAppealedIssueList().length !== 0 || civilCase.getAppealToCase() !== '-' || civilCase.getClockDateByCaseEventCode('INAP') !== ''">
    <div id='V001' class="panel-title ">
        Appeal to Higher Court
    </div>
    <div class="panel-body">
      <div class="table-responsive" [class.scroll-hide-xy]="(civilCase.getAppealedIssueList().length === 0)">
      <table id="transferAppeals-appealToHighCourt-table" class="table table-condensed table-striped ">
        <thead>
          <tr>
            <th>
              <span class="field-code ">V001</span>
              <span id="V001">Appealed On</span>
            </th>
            <th>
              <span class="field-code ">V011 </span> 
              <span id="V011">From</span>
            </th>
            <th>
               <span class="field-code ">V008 </span>
               <span id="V008">To</span>
            </th>
            <th>
               <span class="field-code ">V068w </span>
               <span id="V068w">Appealed By</span>
            </th>            
            <th>
               <span class="field-code ">V004d V051d V005d </span>
              <span id="V004d">Appealed Filing & Issue</span>
            </th>            
            <th>
               <span class="field-code ">V006 </span>
               <span id="V006">Returned Result </span>
            </th>
          </tr>
        </thead>
        <tbody>                    
            <tr *ngIf="civilCase.getAppealFromCase() !== '-'">
                <td id="{{'civil-caseDetails-transferAppeals-appealedFromAppealOnDate'}}">
                  <span class="field-code ">json='appealFrom#', 'appealFrom.appealDate'</span>
                  {{civilCase.getAppealFromAppealDate() | date:'MM/dd/yyyy'}} {{civilCase.getPerfectedIndication('FROM')}}
                </td>
                <td id="{{'civil-caseDetails-transferAppeals-appealedFromAppealFromCaseNumber'}}">
                  <span class="field-code ">json='appealFrom.caseNumber.formattedShortFileNumber'</span>
                  {{civilCase.getAppealFromCaseNumber()}}
                </td>
                <td id="{{'civil-caseDetails-transferAppeals-appealedFromAppealedToCase'}}">
                  <span class="field-code ">json='civilCase.caseNumber.fileNumber'</span>
                  <div *ngIf="civilCase.getAppealFromPaidIndicator() !== 'N'">
                    {{civilCase.getCourtTypeName(civilCase.getCaseNumber())}} {{civilCase.getCaseNumber()}}
                  </div>
                  <div *ngIf="civilCase.getAppealFromPaidIndicator() === 'N'">
                    PENDING
                  </div>                  
                </td>
                <td id="{{'civil-caseDetails-transferAppeals-appealedFromAppealedByParty'}}">
                  <span class="field-code ">json='appealFrom.partyRefs'</span>
                  <div *ngIf="civilCase.getAppealFromCase().partyRefs.length !== 0">
                    <tr *ngFor="let pName of civilCase.getPartyNamesByPartyRefList(civilCase.getAppealFromCase().partyRefs)">
                      {{pName}}
                    </tr>
                  </div>
                  <div *ngIf="civilCase.getAppealFromCase().partyRefs.length === 0">
                    -
                  </div>  
                </td>            
                <td id="{{'civil-caseDetails-transferAppeals-appealedFromIssue'}}">
                  <span class="field-code ">json=''</span>
                  -
                </td>            
                <td id="{{'civil-caseDetails-transferAppeals-appealFromResultReturnedByCourt'}}">
                  <span class="field-code ">json=''</span>
                  -
                </td>
          </tr> 

          <tr *ngIf="civilCase.getAppealToCase() !== '-'">
            <td id="{{'civil-caseDetails-transferAppeals-appealedToAppealOnDate'}}">
              <span class="field-code ">json='appealTo#', 'appealTo.appealDate'</span>
                {{civilCase.getAppealToAppealDate() | date:'MM/dd/yyyy'}} {{civilCase.getPerfectedIndication('TO')}}
            </td>
            <td id="{{'civil-caseDetails-transferAppeals-appealedToAppealFromCaseNumber'}}">
              <span class="field-code ">json='civilCase.caseNumber.fileNumber'</span>
              {{civilCase.getCaseNumber()}}
            </td>
            <td id="{{'civil-caseDetails-transferAppeals-appealedToAppealedToCase'}}">
              <span class="field-code ">json='appealTo.caseNumber.formattedShortFileNumber'</span>
              <div *ngIf="civilCase.getAppealToPaidIndicator() !== 'N'">
                  {{civilCase.getAppealToCaseNumber()}}
                </div>
                <div *ngIf="civilCase.getAppealToPaidIndicator() === 'N'">
                  PENDING
                </div> 
            </td>
            <td id="{{'civil-caseDetails-transferAppeals-appealedToAppealedByParty'}}">
              <span class="field-code ">json='appealTo.partyRefs'</span>
              <div *ngIf="civilCase.getAppealToCase().partyRefs.length !== 0">
                <tr *ngFor="let pName of civilCase.getPartyNamesByPartyRefList(civilCase.getAppealToCase().partyRefs)">
                  {{pName}}
                </tr>
              </div>
              <div *ngIf="civilCase.getAppealToCase().partyRefs.length === 0">
                -
              </div>
            </td>            
            <td id="{{'civil-caseDetails-transferAppeals-appealedToIssue'}}">
              <span class="field-code ">json=''</span>
              -
            </td>            
            <td id="{{'civil-caseDetails-transferAppeals-appealToResultReturnedByCourt'}}">
              <span class="field-code ">json=''</span>
              -
            </td>
          </tr>  

          <tr *ngFor="let appeal of civilCase.getAppealedIssueList(); let ap = index">
              <td id="{{'civil-caseDetails-transferAppeals-appealOnDate-' + ap}}">
                <span class="field-code ">json='appealsList','appealDate'</span>
                  {{appeal.getAppealClockDate() | date:'MM/dd/yyyy'}}
              </td>
              <td id="{{'civil-caseDetails-transferAppeals-courtTypeNameAndNumber-' + ap}}">
                <span class="field-code ">json='civilCase.caseNumber.fileNumber'</span>
                {{civilCase.getCaseNumber()}}
              </td>
              <td id="{{'civil-caseDetails-transferAppeals-appealedToCase-' + ap}}">
                <span class="field-code ">json='appealsList','paidInd#, appealTo.formattedShortFileNumber'</span>
                {{appeal.getAppealedToCourt()}}
              </td>
              <td id="{{'civil-caseDetails-transferAppeals-appealedToAppealedByParty-' + ap}}">
                <span class="field-code ">json='appealsList','partyRefs'</span>
                <div *ngIf="appeal.getAppealedByPartyRefList().length !== 0">
                  <tr *ngFor="let pName of civilCase.getPartyNamesByPartyRefList(appeal.getAppealedByPartyRefList())">
                    {{pName}}
                  </tr>
                </div>
                <div *ngIf="appeal.getAppealedByPartyRefList().length === 0">
                  -
                </div>                
              </td>            
              <td id="{{'civil-caseDetails-transferAppeals-appealedIssueClockDate-' + ap}}">
                <span class="field-code ">json='appealsList','pleading.clockDate', 'pleadingType.description', 'issueType.description', 'appealedIssueRef'</span>
                <div *ngIf="civilCase.getCaseType() !== 'CVM'">
                  {{appeal.getAppealedIssueClockDate(civilCase) | date:'MM/dd/yyyy'}} {{appeal.getAppealedPleadingType(civilCase)}} - {{appeal.getAppealedIssueType(civilCase) }}
                </div>
                <div *ngIf="civilCase.getCaseType() === 'CVM'">
                  -
                </div>                  
              </td>            
              <td id="{{'civil-caseDetails-transferAppeals-resultReturnedByCourt-' + ap}}">
                <span class="field-code ">json='appealsList','appealResultCode.description'</span>
                {{appeal.getReturnDate(civilCase) | date:'MM/dd/yyyy'}} {{appeal.getResultReturnedByCourt()}}
              </td>
            </tr>
        </tbody>
      </table>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/civil/transfer-appeals/transfer-appeals.component.html